module.exports = __webpack_public_path__ + "img/002.ccb46b39.jpg";